import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { DateService } from '../../shared/services/date.service';

@Component({
  standalone: false,
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrl: './transactions.component.scss'
})
export class TransactionsComponent {

  gridApi: any;
  apiUrl: any;
  selectedFromDate: any;
  selectedToDate: any;
  transactionType: string = 'all';

  constructor(private _api: ApiService,
    private _dateService: DateService
  ) {

  }

  columnDefs: ColDef[] = [
    {
      headerName: 'Type',
      field: 'isRemittance',
      editable: false,
      filter: false,
      width: 250,
      valueFormatter: (params: any) => {
        if (!params.data) {
          return 'Unknown';
        }
        
        const isRemittance = params.data.isRemittance;
        const isBill = params.data.isBill;
        
        if (!isRemittance) {
          return 'Payment';
        } else if (isRemittance && isBill) {
          return 'Bill Payment';
        } else if (isRemittance && !isBill) {
          return 'Remittance';
        }
        
        return 'Unknown';
      },
      cellClass: (params: any) => {
        if (!params.data) {
          return 'text-muted'; // Unknown (gray)
        }
        
        const isRemittance = params.data.isRemittance;
        const isBill = params.data.isBill;
        
        if (!isRemittance) {
          return 'text-success'; // Payment (green)
        } else if (isRemittance && isBill) {
          return 'text-warning'; // Bill Payment (yellow)
        } else if (isRemittance && !isBill) {
          return 'text-primary'; // Remittance (blue)
        }
        
        return 'text-muted'; // Unknown (gray)
      }
    },
    {
      headerName: 'Transaction Id',
      field: '_id',
      editable: false,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        if (!params.value) return '';
        return String(params.value).slice(-8);
      }
    },
    {
      headerName: 'Merchant Name',
      field: 'merchantName',
      editable: false,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Customer Name',
      field: 'customerId.name',
      editable: false,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    // {
    //   headerName: 'Customer EmailId',
    //   field: 'customerId.emailId',
    //   editable: false,
    //   filter: true,
    // },
    {
      headerName: 'Source Partner',
      field: 'sourceBankId.name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Source Country',
      field: 'originationCountry.displayName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Amount',
      field: 'conversions',
      editable: false,
      filter: true,
      valueFormatter: (params: any) => {
        try {
          const conversions = JSON.parse(params.value);
          return conversions.customerPays.currency+' '+conversions.customerPays.amount;
        } catch (e) {
          return '-';
        }
      }
    },
    {
      headerName: 'Location',
      field: 'location',
      editable: false,
      filter: false,
      valueFormatter: (params) => this.getLatLongFromLocation(params.value),
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Date',
      field: 'createdAt',
      editable: false,
      filter: false,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value),
    },
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: { mode: 'multiple' },
    context: {
      componentParent: this,
    },
  };

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  getLatLongFromLocation(value: string): string {
    if (!value) return '-';
    try {
      const loc = (JSON.parse(value));

     
      if (loc.coords) {
        const latitude = loc.coords.latitude;
        const longitude = loc.coords.longitude;
        return latitude + ', ' + longitude;
      }
      return '-';
    } catch (e) {
      return '-';
    }
  }


  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/transactions' + '?_page=' + request._page + '&_limit=' + request._limit;
        
        // Add transaction type filter
        if (this.transactionType === 'payment') {
          this.apiUrl += '&isRemittance=false';
        } else if (this.transactionType === 'bill-payment') {
          this.apiUrl += '&isRemittance=true&isBill=true';
        } else if (this.transactionType === 'remittance') {
          this.apiUrl += '&isRemittance=true&isBill=false';
        }
        if (vm.gridApi) {
          const filterData = vm.gridApi.getFilterModel();
          Object.keys(filterData).forEach(function (k) {
            if (k && filterData[k]) {
              var filterValue = String(filterData[k].filter).replace(/[<>"';&]/g, '').slice(0, 200);
              if (!filterValue) return;
              if (k === 'amount') {
                vm.apiUrl += "&" + k + "_FULLMATCH=" + encodeURIComponent(filterValue);
              } else {
                vm.apiUrl += "&" + k + "_like=" + encodeURIComponent(filterValue);
              }
            }
          });
        }

        if (vm.selectedFromDate && vm.selectedToDate) {
          const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
          const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
          if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
            vm.apiUrl += '&createdAtdatePickerRange=' + fromTimestamp + ',' + toTimestamp;
          }
        }
        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onDateSelected(result: { fromDate: any, toDate: any }) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  filterTransactions(type: string) {
    this.transactionType = type;
    if (this.gridApi) {
      this.gridApi.refreshInfiniteCache();
    }
  }

}
